import React, { Fragment, useState } from "react";
import Fuse from "fuse.js";
import { FaShareAlt } from "react-icons/fa";
import Heading from "components/Elements/Heading";
import DataConnectors from "../../pages/SourcePage/DataConnectors";

const fuseOptions = {
  shouldSort: true,
  threshold: 0.4,
  location: 0,
  distance: 50,
  maxPatternLength: 12,
  minMatchCharLength: 3,
  keys: ["name"],
};

const Catalog = ({ sources }) => {
  const [query, setQueryState] = useState("");
  const [sourceList] = useState(sources);

  const renderSources = () => {
    const fuse = new Fuse(sourceList, fuseOptions);
    const data = query ? fuse.search(query) : sourceList;

    if (data.length === 0) {
      return (
        <div className="col-12 d-flex flex-column align-items-center">
          <Heading size={5} className={"mt-5"}>
            No sources found
          </Heading>
        </div>
      );
    } else {
      return data.map((data, i) => <DataConnectors key={i} data={data} />);
    }
  };

  // const renderUploads = () => {
  //   const fuse = new Fuse(uploadList, fuseOptions);
  //   const data = query ? fuse.search(query) : uploadList;

  //   if (data.length === 0) {
  //     return (
  //       <div className="col-12 d-flex flex-column align-items-center">
  //         <Heading size={5} className={"mt-5"}>
  //           No uploads found
  //         </Heading>
  //       </div>
  //     );
  //   } else {
  //     return data.map((data, i) => <DataUploads key={i} data={data} />);
  //   }
  // };

  const handleSearch = (e) => {
    setQueryState(e.target.value);
  };

  return (
    <Fragment>
      <div className="shadow-sm pt-4 m-4 h-100 bg-white">
        <div className="col-2 px-4">
          <div style={{ position: "relative" }}>
            <form>
              <div className="form-group ml-2 mr-2">
                <input
                  placeholder="Search Sources"
                  onChange={(e) => handleSearch(e)}
                  className="sources-border-between"
                />
              </div>
            </form>
          </div>
        </div>

        <div className="source-list px-4 pb-5">
          <small className="py-1">Data Connectors</small>
          <div className="row d-flex flex-wrap justify-content-left align-items-start">
            {renderSources()}
          </div>

          {/* <small className="py-5">Data Uploads</small>
          <div className="row d-flex flex-wrap justify-content-left align-items-start">
            {renderUploads()}
          </div> */}
        </div>

        <div className="small-text p-3 text-center">
          <FaShareAlt size="1.7rem" />
          <Heading size={4} className="pt-4">
            More Connectors Coming Soon
          </Heading>
          <small>
            Soon, all of your connectors will be available to administered here.
            We will let <br />
            you know as we add more connector controls to the admin panel.
          </small>
        </div>
      </div>
    </Fragment>
  );
};
export default Catalog;
